import { render, staticRenderFns } from "./LgxOldJSONRenderer.vue?vue&type=template&id=8f57236e&"
import script from "./LgxOldJSONRenderer.vue?vue&type=script&lang=js&"
export * from "./LgxOldJSONRenderer.vue?vue&type=script&lang=js&"
import style0 from "./LgxOldJSONRenderer.vue?vue&type=style&index=0&id=8f57236e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports